import { useQuery } from 'react-query';

const fetchRegions = async () => {
  const idToken = sessionStorage.getItem('idToken') || false;

  if (!idToken) {
    console.error('Missing ID Token');
    return;
  }

  let regionsEndPoint;
  switch (DEPLOYMENT_TARGET) {
    case 'prod':
      regionsEndPoint = `https://accounts.cloudone.trendmicro.com/api/regions`;
      break;
    case 'stage':
      regionsEndPoint = `https://accounts.staging-cloudone.trendmicro.com/api/regions`;
      break;
    case 'drsim':
      regionsEndPoint = `https://accounts.drsim-cloudone.trendmicro.com/api/regions`;
      break;
    case 'govcloud-prod':
      regionsEndPoint = `https://accounts.cloudonegov.trendmicro.com/api/regions`;
      break;
    case 'govcloud-staging':
      regionsEndPoint = `https://accounts.staging-cloudonegov.trendmicro.com/api/regions`;
      break;
    case 'alpha':
    case 'dev':
      regionsEndPoint =
        window.location.hostname === 'localhost'
          ? '/api/regions'
          : `https://accounts.dev-cloudone.trendmicro.com/api/regions`;
      break;
    default:
      regionsEndPoint = null;
      return console.error('No regions end-point found.');
  }

  try {
    const response = await fetch(regionsEndPoint, {
      headers: {
        'api-version': 'v1',
        Authorization: `Bearer ${idToken}`,
      },
    });

    if (!response.ok) {
      throw new Error(`An error has occurred: ${response.status}`);
    }

    const { regions } = await response.json();
    return regions;
  } catch (e) {
    console.error('Error fetching cloud one regions');
  }
};

export function useRegionsList() {
  return useQuery(['get-regions'], () => fetchRegions());
}
